<div
  class="bg-dark text-white justify-content-center justify-content-between preview-toolbar d-flex"
  confirmByKeypress
  (confirmed)="nextFile()"
  (cancelled)="close()"
>
  <div class="col-auto text-white">
    <div class="preview-file-name ms-1">{{fileName()}}</div>
  </div>

  <div class="d-flex align-items-center col-auto">
    <sk-button size="sm"
               appearance="icon"
               id="buttonGoToParentFolderId"
               [hidden]="!showGoToFolder"
               [matTooltip]="'label.dms.GoToFolder' | translate"
               (click)="goToParentFolder()"
               data-test="file-pireview-modal_go-to-parent-folder">
      <i class="icon fas fa-folder-open text-white"></i>
    </sk-button>
    <sk-button size="sm"
               appearance="icon"
               data-test="file-pireview-modal_download-file"
               (click)="downloadFile()"
               [matTooltip]="'label.Download' | translate">
      <i class="icon fas fa-download text-white"></i>
    </sk-button>

    <sk-button
      [size]="'sm'"
      [hidden]="!showFileInfo"
      [appearance]="'icon'"
      [matTooltip]="'label.dms.ShowFileInfo' | translate"
      (click)="openFileInfoInNewTab()"
      data-test="file-pireview-modal_show-file-info"
      >
      <i class="icon fas fa-info text-white"></i>
    </sk-button>

    <sk-button size="sm"
               appearance="icon"
               [matTooltip]="'label.Close' | translate" (click)="closeWithoutResult()">
      <i class="icon fas fa-times text-white"></i>
    </sk-button>
  </div>
</div>

<div class="modal-body-file-preview">
  @if (isImage() || isPdf()) {
    @if (isImage()) {
      <div class="image-preview" [class.flex-full-column]="isError()">
        @if (isError()) {
          <p class="sk-alert sk-alert-warning mb-0 rounded-0 flex-valign">
            <span class="flex-col-auto me-2">{{ 'label.dms.FileLoadError' | translate }}</span>
          </p>
        }
        @else {
          <pinch-zoom [disableZoomControl]="'never'">
            <img [src]="fileLink()" alt="image preview" (load)="onImageLoaded($event)" (error)="onImageError()" />
          </pinch-zoom>
        }
      </div>
    }

    @if (isPdf()) {
      <div class="pdf-preview" [class.flex-full-column]="isError()">
        @if (isError()) {
          <p class="sk-alert sk-alert-warning mb-0 rounded-0 flex-valign">
            <span class="flex-col-auto me-2">{{ 'message.PdfWarning' | translate }}</span>
            <sk-button size="m"
                       appearance="solid"
                       data-test="file-pireview-downloadFile-button"
                       (click)="downloadFile()"
                       [label]="'label.Download' | translate">
            </sk-button>
          </p>
        } @else {
          <ngx-extended-pdf-viewer
            [style.visibility.visible]="previewReady()"
            [style.visibility.hidden]="!previewReady()"
            [src]="fileLink()"
            [theme]="'dark'"
            [textLayer]="true"
            [handTool]="false"
            [showHandToolButton]="true"
            [showRotateButton]="false"
            [showScrollingButtons]="false"
            [showPresentationModeButton]="false"
            [showOpenFileButton]="false"
            [showPrintButton]="false"
            [showDownloadButton]="false"
            [showRotateButton]="true"
            [minZoom]="0.25"
            [maxZoom]="4"
            [(sidebarVisible)]="sidebarVisible"
            (pdfLoaded)="onPdfLoaded($event)"
            (pdfLoadingFailed)="onPdfLoadingFailed($event)"
          ></ngx-extended-pdf-viewer>
        }
      </div>
    }

    @if (!previewReady()) {
      <iris-simple-loader class="absolute-box preview-loader"></iris-simple-loader>
    }
  }

  @if (isDocument() && documentBlob()) {
    <div class="frame-type-document">
      <iframe
        [width]="isExcelFile() ? '100%' : 985"
        height="100%"
        title="Document preview"
        sandbox="allow-scripts"
        [src]="documentBlob() | safeResourceUrl">
        <div>
          <a [href]="fileLink()"> {{'error.file.preview' | translate}} </a>
        </div>
      </iframe>
    </div>
  }

  @if (!previewFileType()) {
    <div class="preview-file-error">
      <p><a [href]="fileLink()"> {{'error.file.preview' | translate}} </a></p>
    </div>
  }

  <div class="navigation-button-wrapper navigation-left" [class.pdf-nav]="isPdf()" [hidden]="prevButtonDisabled">
    <sk-button
      [appearance]="'icon'"
      [disabled]="prevButtonDisabled"
      (click)="prevFile()"
      data-test="file-pireview-modal_prev-file"
      class="navigation-button">
      <i class="icon fas fa-caret-left fa-lg"></i>
    </sk-button>
  </div>

  <div class="navigation-button-wrapper navigation-right" [class.pdf-nav]="isPdf()" [hidden]="nextButtonDisabled">
    <sk-button
      [appearance]="'icon'"
      [disabled]="nextButtonDisabled"
      (click)="nextFile()"
      data-test="file-pireview-modal_next-file"
      class="navigation-button">
      <i class="icon fas fa-caret-right fa-lg"></i>
    </sk-button>
  </div>
</div>
